"use strict";

module.exports = {
  delimiter: ['{', '}']
};